import audioConfig from "./audio.config";
import gameplayConfig from "./gameplay.config";
import graphicsConfig from "./graphics.config";
import phaserConfig from "./phaser.config";
import soundConfig from "./sound.config";
import worldConfig from "./world.config";
export default {
    audio: audioConfig,
    gameplay: gameplayConfig,
    graphics: graphicsConfig,
    phaser: phaserConfig,
    sound: soundConfig,
    world: worldConfig,
};
